module.exports = __webpack_public_path__ + "img/three.fc9dcaaa.png";